import { render, staticRenderFns } from "./InsertCourse.vue?vue&type=template&id=07358c16&scoped=true"
import script from "./InsertCourse.vue?vue&type=script&lang=js"
export * from "./InsertCourse.vue?vue&type=script&lang=js"
import style0 from "./InsertCourse.vue?vue&type=style&index=0&id=07358c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07358c16",
  null
  
)

export default component.exports